import Wingo from "./games/Wingo";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Notification from "./pages/Notification";
import BetRecords from "./pages/BetRecords";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Wingo />} />
          <Route path="/notification" element={<Notification />} />
          <Route path="/bet-records" element={<BetRecords />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
